/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Return_Order_Not_DeliveredInputs */

const vi_error_return_order_not_delivered = /** @type {(inputs: Error_Return_Order_Not_DeliveredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chỉ trả hàng được cho đơn đã giao.`)
};

/**

* @param {Error_Return_Order_Not_DeliveredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_return_order_not_delivered = /** @type {((inputs?: Error_Return_Order_Not_DeliveredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Return_Order_Not_DeliveredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_return_order_not_delivered(inputs)
});